import { useState } from 'react';
import axios from 'axios';
import useDevKey from './useDevKey';

export default function useAddSubscriber() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const devKey = useDevKey();

  const addSubscriber = async (data) => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await axios.post('/api/addSubscriber',  data, {
        headers: {
          'Dev-Key' : devKey
        }
      });
      setIsLoading(false);
      return response.data; 
    } catch (err) {
      setIsLoading(false);
      setError(err.response.data.error);
      return err; 
    }
  }

  return {
    addSubscriber,
    isLoading,
    error,
  }
}
